module.exports = __webpack_public_path__ + "static/media/5.question.2ceef0f3.mp4";